import {Component, ElementRef} from '@angular/core';
import * as $ from 'jquery';
import MenuTogglerService from "../../services/menuToggler.service";

@Component({
    selector: 'app',
    template: require('./app.component.html'),
    styles: [String(require('./app.styl'))]
})

export class AppComponent {

    constructor(private element: ElementRef,
                private toggler: MenuTogglerService) {
    }

    private notificationOptions = {
        position: ['top', 'right'],
        timeOut: 5000,
        preventDuplicates: 1
    }

    ngAfterContentInit() {
        this.toggler.app = $(this.element.nativeElement)['find']('.app');
        this.toggler.appContainer = $(this.element.nativeElement)['find']('.app--container');
    }

}



// WEBPACK FOOTER //
// ./src/app/components/app/app.component.ts